import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO/templates`;
const THUMBS = `${BASE}/thumbnails/ctv`;
const PREVIEWS = `${BASE}/previews/macro-ctv`;

export const macroCTV = defineTemplate({
  mode: 'legacy',
  id: 'macro-ctv',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'CTV',
  thumbnail: {
    url: `${THUMBS}/ctv_1920x1080.png`,
    optimizedUrl: `${THUMBS}/optimized/ctv_1920x1080.png`,

    aspectRatio: 'horizontal'
  },
  previewByResolution: {
    '300x250': { kind: 'video', url: `${PREVIEWS}/macro-ctv_300x250.mp4` },
    '300x600': { kind: 'video', url: `${PREVIEWS}/macro-ctv_300x600.mp4` },
    '1080x1080': { kind: 'video', url: `${PREVIEWS}/macro-ctv_1080x1080.mp4` },
    '1080x1350': { kind: 'video', url: `${PREVIEWS}/macro-ctv_1080x1350.mp4` },
    '1920x1080': { kind: 'video', url: `${PREVIEWS}/macro-ctv_1920x1080.mp4` }
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'text',
      label: 'Slogan (opcional)',
      type: 'input',
      placeholder: 'Máx. 20 caracteres por línea. Presioná Enter para saltos de línea.',
      required: false,
      multiline: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/description.png'
    },
    {
      key: 'video',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/video.png'
    },
    {
      key: 'background',
      label: 'Imagen de fondo',
      type: 'select',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/background.png',
      options: [{ value: `${THUMBS}/fondo.png`, label: 'Fondo azul' }]
    },
    {
      key: 'logo',
      label: 'Logo (opcional)',
      type: 'visual-select',
      required: false,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/logo.png',
      options: [
        {
          id: 'logo-vertical',
          value: `${THUMBS}/logo_macro.png`,
          label: 'Vertical',
          imageUrl: `${THUMBS}/logo_macro.png`,
          backgroundColor: '#0139E3'
        },
        {
          id: 'logo-horizontal',
          value: `${THUMBS}/logo_macro_w.png`,
          label: 'Horizontal',
          imageUrl: `${THUMBS}/logo_macro_w.png`,
          backgroundColor: '#0139E3'
        }
      ]
    }
  ],
  promptTemplate: `Haceme un video CTV, usando este video: "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO/examples/ctv/macro.mp4",
Con este texto:
"Sabemos lo
que valemos
los argentinos",
Con este logo: "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO/examples/ctv/macro.png",
y este fondo: "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO/examples/ctv/fondo.png"`
});
